export { default as i18n } from "./i18n";
export { default } from "./BookingViewContainer";
export { default as reducer } from "./reducer";

import { BookingViewState as TBookingViewState } from "./types";
export type BookingViewState = TBookingViewState;
